import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

const navLinks = [
  { label: "首页", path: "/" },
  { label: "漫画分类", path: "/category/all" },
  { label: "关于我们", path: "/about" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur-md border-b border-background-200/60"
          : "bg-transparent"
      }`}
    >
      <nav className="mx-auto flex max-w-7xl items-center justify-between px-4 md:px-6 h-16">
        <Link
          to="/"
          className="flex items-center gap-2 cursor-pointer"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
        >
          <span className="text-xl font-heading font-bold text-primary-500 tracking-tight whitespace-nowrap">
            土豪漫画
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-1">
          {navLinks.map((link) => {
            const isActive =
              link.path === "/"
                ? location.pathname === "/"
                : location.pathname.startsWith(link.path);
            return (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
                className={`relative px-4 py-2 text-sm font-medium rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer ${
                  isActive
                    ? "text-primary-500 bg-primary-500/10"
                    : "text-foreground-600 hover:text-foreground-900 hover:bg-background-100"
                }`}
              >
                {link.label}
                {isActive && (
                  <span className="absolute bottom-0.5 left-1/2 -translate-x-1/2 w-1 h-1 rounded-full bg-primary-500" />
                )}
              </Link>
            );
          })}
        </div>

        <div className="hidden md:flex items-center gap-3">
          <button className="w-9 h-9 flex items-center justify-center rounded-full bg-background-100 hover:bg-background-200 text-foreground-600 transition-colors duration-200 cursor-pointer whitespace-nowrap">
            <i className="ri-search-line text-base"></i>
          </button>
        </div>

        <button
          className="md:hidden w-9 h-9 flex items-center justify-center rounded-full bg-background-100 text-foreground-600 cursor-pointer whitespace-nowrap"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="菜单"
        >
          <i
            className={`text-lg ${mobileOpen ? "ri-close-line" : "ri-menu-line"}`}
          ></i>
        </button>
      </nav>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-b border-background-200/60 px-4 pb-4">
          {navLinks.map((link) => {
            const isActive =
              link.path === "/"
                ? location.pathname === "/"
                : location.pathname.startsWith(link.path);
            return (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
                className={`block py-3 text-sm font-medium transition-colors duration-200 cursor-pointer ${
                  isActive
                    ? "text-primary-500"
                    : "text-foreground-600 hover:text-foreground-900"
                }`}
              >
                {link.label}
              </Link>
            );
          })}
        </div>
      )}
    </header>
  );
}